import {BaseDTO} from "../_baseDTO.interface";

export interface NegotiationNoteDTO extends BaseDTO {
  negotiationId: string;
  note: string;
}
